import React, { useEffect, useState } from "react";

const useDebounce = (delay: number) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(searchTerm);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [searchTerm, delay]);

  return {
    debouncedValue,
    searchTerm,
    handleSearch: (
      e: React.ChangeEvent<HTMLInputElement> | null,
      val?: string | undefined,
    ) => {
      if (e) setSearchTerm(e.target.value);
      else setSearchTerm(val as string);
    },
    resetSearch: () => setSearchTerm(""),
  };
};

export default useDebounce;
